module.exports = __webpack_public_path__ + "static/media/mapUsa.79925713.png";